import { api } from './client'

function parseFilename(contentDisposition?: string): string | null {
  if (!contentDisposition) return null
  const m = /filename="?([^"]+)"?/.exec(contentDisposition)
  return m?.[1] ?? null
}

function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

/**
 * Скачивание xlsx через RBAC-эндпоинт Task 6. responseType:'blob' + Authorization
 * (in-memory token из interceptor'а). 403 → ошибка пробрасывается наверх
 * (вызывающий показывает уведомление), битый/пустой файл не качается.
 */
export async function downloadEmployeeReportXlsx(id: string, from: string, to: string): Promise<void> {
  const r = await api.get(`/exports/employee-report.xlsx`, {
    params: { id, from, to },
    responseType: 'blob',
  })
  const filename = parseFilename(r.headers['content-disposition'] as string | undefined) ?? `employee-${id}.xlsx`
  triggerDownload(r.data as Blob, filename)
}
